import 'core-js/stable';
import 'regenerator-runtime/runtime';

import { useEffect } from 'react';
import { createRoot, type Root } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import Router from '@/router';
import '@/styles/main.scss';

import { initAnalytics } from '@/utils/analytics';
import { initSentry } from '@/utils/sentry';
// 兼容低端机var不识别
import 'antd-mobile/bundle/css-vars-patch.css';
import 'uno.css';
// import '@/styles/tiechu/theme.css';
import { AliveScope } from 'react-activation';
import { report, EVENTTYPES } from '@/utils/analytics';
import { useCookie } from '@/hooks/useCookie';
import { cookieUnionIdKey } from '@/config';

initSentry();
initAnalytics();

const container = document.getElementById('root')!;

type RootHost = HTMLElement & { __reactRoot?: Root };

function getOrCreateRoot(host: RootHost): Root {
  if (!host.__reactRoot) {
    host.__reactRoot = createRoot(host);
  }
  return host.__reactRoot;
}

const App = () => {
  const { getCookie } = useCookie();

  useEffect(() => {
    const isWxAuthPageShow = sessionStorage.getItem('wx_auth_page_show');
    const cookieUnionId = getCookie(cookieUnionIdKey);

    if (isWxAuthPageShow) {
      // 有微信授权标识则清空
      sessionStorage.removeItem('wx_auth_page_show');
      // 微信授权 session 标识，cookie unionId 都存在则上报成功
      if (cookieUnionId) {
        report({
          event_type: EVENTTYPES.PAGE_SHOW,
          event_id: 'wx_auth_success',
        });
      }
    }
  }, [getCookie]);

  return (
    <BrowserRouter basename='/mweb'>
      <AliveScope>
        <Router />
      </AliveScope>
    </BrowserRouter>
  )
}

getOrCreateRoot(container).render(<App />);
